function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M21.21 15.89A10 10 0 1 1 8 2.83"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M22 12A10 10 0 0 0 12 2v10z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-pie-chart icon",
    style: {
      "height": "0.9em",
      "width": "0.9em"
    }
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/pie-chart.6c925faf.svg";
export { SvgComponent as ReactComponent };